import { Line, mixins } from 'vue-chartjs';

export default {
  name: 'line-chart',
  mixins: [mixins.reactiveProp],
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      delayed: false,
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
};
